module.exports = __webpack_public_path__ + "static/img/icon_individual_normal@2x.1786686659715.png";